import { NotificationPreferencesDto } from "../../..";

export const defaultNotificationPreferences: NotificationPreferencesDto = {
  industrial: [
    {
      topic: "brownfields",
      title: "Brownfields",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "superfunds",
      title: "Superfunds",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "natural_gas_pipelines",
      title: "Natural Gas Pipelines",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "oil_wells",
      title: "Oil, Gas, & Fracking Wells",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
  ],

  infrastructure: [
    {
      topic: "cell_towers",
      title: "Cell Towers",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "solid_waste_landfills",
      title: "Solid Waste Landfills",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "high_voltage_lines",
      title: "High Voltage Lines",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "power_plants",
      title: "Power Plants",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "nuclear_power_plant_warning",
      title: "Nuclear Power Plant Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "radiological_hazard_warning",
      title: "Radiological Hazard Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hazardous_materials_warning",
      title: "Hazardous Materials Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
  ],
  pollution: [
    {
      topic: "air_quality_alert",
      title: "Air Quality Alerts",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "air_stagnation_advisory",
      title: "Air Stagnation Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "dense_smoke_advisory",
      title: "Dense Smoke Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "toxic_release_inventory",
      title: "Toxic Release Inventory",
      type: "diff_check",
      email_enabled: true,
      push_notifications: true,
    },
  ],
  natural: [
    {
      topic: "winter_storm_watch",
      title: "Winter Storm Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "blizzard_warning",
      title: "Blizzard Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "winter_storm_warning",
      title: "Winter Storm Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "ice_storm_warning",
      title: "Ice Storm Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "winter_weather_advisory",
      title: "Winter Weather Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "freeze_watch",
      title: "Freeze Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "freeze_warning",
      title: "Freeze Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "frost_advisory",
      title: "Frost Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "wind_chill_advisory",
      title: "Wind Chill Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "wind_chill_warning",
      title: "Wind Chill Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "fire_weather_watch",
      title: "Fire Weather Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "red_flag_warning",
      title: "Red Flag Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "dense_fog_advisory",
      title: "Dense Fog Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "high_wind_watch",
      title: "High Wind Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "high_wind_warning",
      title: "High Wind Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "wind_advisory",
      title: "Wind Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "severe_thunderstorm_watch",
      title: "Severe Thunderstorm Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "severe_thunderstorm_warning",
      title: "Severe Thunderstorm Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "tornado_watch",
      title: "Tornado Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "tornado_warning",
      title: "Tornado Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "extreme_wind_warning",
      title: "Extreme Wind Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "small_craft_advisory",
      title: "Small Craft Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "gale_warning",
      title: "Gale Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "storm_warning",
      title: "Storm Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hurricane_force_wind_warning",
      title: "Hurricane Force Wind Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "special_marine_warning",
      title: "Special Marine Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "coastal_flood_watch",
      title: "Coastal Flood Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "coastal_flood_warning",
      title: "Coastal Flood Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "coastal_flood_advisory",
      title: "Coastal Flood Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "flash_flood_watch",
      title: "Flash Flood Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "flash_flood_warning",
      title: "Flash Flood Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "flood_watch",
      title: "Flood Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "flood_warning",
      title: "Flood Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "river_flood_watch",
      title: "River Flood Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "river_flood_warning",
      title: "River Flood Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "excessive_heat_watch",
      title: "Excessive Heat Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "excessive_heat_warning",
      title: "Excessive Heat Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "heat_advisory",
      title: "Heat Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "tropical_storm_watch",
      title: "Tropical Storm Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "tropical_storm_warning",
      title: "Tropical Storm Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hurricane_watch",
      title: "Hurricane Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hurricane_warning",
      title: "Hurricane Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "ashfall_advisory",
      title: "Ashfall Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "ashfall_warning",
      title: "Ashfall Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "avalanche_advisory",
      title: "Avalanche Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "avalanche_warning",
      title: "Avalanche Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "avalanche_watch",
      title: "Avalanche Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "beach_hazards_statement",
      title: "Beach Hazards Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "blizzard_watch",
      title: "Blizzard Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "blowing_dust_advisory",
      title: "Blowing Dust Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "blowing_dust_warning",
      title: "Blowing Dust Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },

    {
      topic: "coastal_flood_statement",
      title: "Coastal Flood Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "dust_advisory",
      title: "Dust Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "dust_storm_warning",
      title: "Dust Storm Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "earthquake_warning",
      title: "Earthquake Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "evacuation_immediate",
      title: "Evacuation - Immediate",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "extreme_cold_warning",
      title: "Extreme Cold Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "extreme_cold_watch",
      title: "Extreme Cold Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "extreme_fire_danger",
      title: "Extreme Fire Danger",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "fire_warning",
      title: "Fire Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "flash_flood_statement",
      title: "Flash Flood Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "flood_advisory",
      title: "Flood Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "flood_statement",
      title: "Flood Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "freezing_fog_advisory",
      title: "Freezing Fog Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "freezing_rain_advisory",
      title: "Freezing Rain Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "freezing_spray_advisory",
      title: "Freezing Spray Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "gale_watch",
      title: "Gale Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hard_freeze_warning",
      title: "Hard Freeze Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hard_freeze_watch",
      title: "Hard Freeze Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },

    {
      topic: "hazardous_seas_warning",
      title: "Hazardous Seas Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hazardous_seas_watch",
      title: "Hazardous Seas Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hazardous_weather_outlook",
      title: "Hazardous Weather Outlook",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "heavy_freezing_spray_warning",
      title: "Heavy Freezing Spray Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "heavy_freezing_spray_watch",
      title: "Heavy Freezing Spray Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "high_surf_advisory",
      title: "High Surf Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "high_surf_warning",
      title: "High Surf Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hurricane_force_wind_watch",
      title: "Hurricane Force Wind Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hurricane_local_statement",
      title: "Hurricane Local Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hydrologic_advisory",
      title: "Hydrologic Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "hydrologic_outlook",
      title: "Hydrologic Outlook",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "lake_effect_snow_advisory",
      title: "Lake Effect Snow Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "lake_effect_snow_warning",
      title: "Lake Effect Snow Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "lake_effect_snow_watch",
      title: "Lake Effect Snow Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "lake_wind_advisory",
      title: "Lake Wind Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "lakeshore_flood_advisory",
      title: "Lakeshore Flood Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "lakeshore_flood_statement",
      title: "Lakeshore Flood Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "lakeshore_flood_warning",
      title: "Lakeshore Flood Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "lakeshore_flood_watch",
      title: "Lakeshore Flood Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "low_water_advisory",
      title: "Low Water Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "marine_weather_statement",
      title: "Marine Weather Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },

    {
      topic: "rip_current_statement",
      title: "Rip Current Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "severe_weather_statement",
      title: "Severe Weather Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },

    {
      topic: "short_term_forecast",
      title: "Short Term Forecast",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },

    {
      topic: "snow_squall_warning",
      title: "Snow Squall Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "special_weather_statement",
      title: "Special Weather Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "small_stream_flood_advisory",
      title: "Small Stream Flood Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "storm_surge_warning",
      title: "Storm Surge Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "storm_surge_watch",
      title: "Storm Surge Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "storm_watch",
      title: "Storm Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "tropical_storm_local_statement",
      title: "Tropical Storm Local Statement",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "tsunami_advisory",
      title: "Tsunami Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "tsunami_warning",
      title: "Tsunami Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "tsunami_watch",
      title: "Tsunami Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "urban_and_small_stream_flood_advisory",
      title: "Urban And Small Stream Flood Advisory",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "volcano_warning",
      title: "Volcano Warning",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
    {
      topic: "wind_chill_watch",
      title: "Wind Chill Watch",
      type: "cap",
      email_enabled: true,
      push_notifications: true,
    },
  ],
  misc: [
    {
      topic: "911_telephone_outage_emergency",
      title: "911 Telephone Outage Emergency",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "administrative_message",
      title: "Administrative Message",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "child_abduction_emergency",
      title: "Child Abduction Emergency",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "civil_danger_warning",
      title: "Civil Danger Warning",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "civil_emergency_message",
      title: "Civil Emergency Message",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "law_enforcement_warning",
      title: "Law Enforcement Warning",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "local_area_emergency",
      title: "Local Area Emergency",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "brisk_wind_advisory",
      title: "Brisk Wind Advisory",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "shelter_in_place_warning",
      title: "Shelter In Place Warning",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "small_craft_advisory_for_hazardous_seas",
      title: "Small Craft Advisory For Hazardous Seas",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "small_craft_advisory_for_rough_bar",
      title: "Small Craft Advisory For Rough Bar",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
    {
      topic: "small_craft_advisory_for_winds",
      title: "Small Craft Advisory For Winds",
      type: "cap",
      email_enabled: false,
      push_notifications: false,
    },
  ],
};
